/**
 * Password recovery service barrel exports.
 */

export {
  PasswordRecoveryError,
  PasswordRecoveryService,
} from './service';

export { readPasswordResetTokenFromUrl } from './url';

export type {
  PasswordRecoveryAcceptedResponse,
  PasswordRecoveryRequest,
  PasswordRecoveryResetRequest,
  PasswordRecoveryResetResponse,
  PasswordRecoveryValidateResponse,
} from './types';
